<template>
  <div class="flex flex-col">
    <div class="bg-surface-container rounded-large flex flex-col" @click="emit('click')">
      <div class="flex flex-row items-center gap-4 p-4">
        <div class="relative flex h-12 w-12 shrink-0 items-center justify-center">
          <BaseIcon v-if="isCompleted" size="24" class="text-on-primary-container z-10"
            >check</BaseIcon
          >
          <span v-else class="text-on-primary text-headline-medium z-10 font-semibold">
            {{ step }}
          </span>
          <BaseShape
            :shape="isActive ? 'sunny' : 'circle'"
            :class="[
              isActive && 'text-primary h-[120%] w-[120%]',
              !isActive && 'text-primary-container h-full w-full',
            ]"
            class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          />
        </div>
        <div class="flex grow flex-col">
          <h4
            class="text-title-large"
            :class="[
              (isActive || isCompleted) && 'text-on-surface',
              !(isActive || isCompleted) && 'text-outline-variant',
            ]"
          >
            {{ title }}
          </h4>
          <p v-if="isActive || isCompleted" class="text-body-medium text-on-surface-variant">
            {{ description }}
          </p>
        </div>
        <div class="">
          <slot />
        </div>
      </div>
      <slot v-if="isActive" name="bottom" />
      <div
        v-if="isActive && hasActionsSlot"
        class="border-outline-variant flex w-full flex-row justify-between border-t py-4 pr-4 pl-16"
      >
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import BaseShape from '@/core/components/base/shapes/BaseShape.vue'
  import { useSlots, computed } from 'vue'

  interface Props {
    step: number
    title: string
    description: string
    isActive?: boolean
    isCompleted?: boolean
  }

  defineProps<Props>()

  const emit = defineEmits<{
    (e: 'click'): void
  }>()
  const slots = useSlots()

  const hasActionsSlot = computed(() => {
    return !!slots.actions
  })
</script>
